import React from 'react'
import PropTypes from 'prop-types'
import * as ModalWrapper from 'react-modal'

import styles from './Modal.module.scss'

import iconClose from 'shared/assets/icons/close.svg'

const customStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.3)'
  },
  content: {
    background: 'rgb(28, 28, 33)',
    border: 'none',
    position: 'relative',
    top: 'initial',
    left: 'initial',
    right: 'initial',
    bottom: 'initial',
    overflow: 'initial',
    borderRadius: '8px',
    padding: '16px'
  }
}

const setSzie = size => {
  switch(size) {
    case 'small':
      return '320px'
    case 'medium':
      return '560px'
    case 'large':
      return '816px'
    
    default:
      return '560px'
  }
}

const Modal = ({
  isOpen,
  onClose,
  children,
  size
}) => {
  customStyles['content']['width'] = setSzie(size)
  
  return (
    <ModalWrapper
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      ariaHideApp={false}
    >
      <img
        className={styles.closeButton}
        src={iconClose}
        onClick={onClose}
      />

      { children }
    </ModalWrapper>
  )
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  size: PropTypes.oneOf([
    'small',
    'medium',
    'large'
  ])
}
Modal.defaultProps = {
  size: 'small'
}

export default Modal
